const orgRole =
  { Owner: 1, Admin: 2, Staff: 3, Other: 4 }

export default orgRole
